import { useEffect, useState } from "react";
import { sleepLengthShort, useSleep } from "./sleepTimer.js";

/** "Sleep 42 min" under the full-screen clock while the sleep timer runs; nothing otherwise. */
export function SleepRemaining() {
  const endsAt = useSleep((state) => state.endsAt);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (endsAt === null) return;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 30_000);
    return () => window.clearInterval(timer);
  }, [endsAt]);
  if (endsAt === null) return null;
  const minutes = Math.max(1, Math.ceil((endsAt - now) / 60_000));
  return <span className="player-surface__sleep">Sleep {sleepLengthShort(minutes)}</span>;
}
